import { Button } from "../../../apps/tripper/components/trekker/Button";

type TripperMapResetButtonProps = {
  onClick: () => void;
};

export const TripperMapResetButton = ({ onClick }: TripperMapResetButtonProps) => (
  <div className="tripper-map-reset-btn">
    <Button
      type="button"
      size="md"
      visual="unstyled"
      className="tripper-map-reset-btn__button"
      onClick={onClick}
    >
      Reset map
    </Button>
  </div>
);
